export default __webpack_public_path__ + "static/events-dark-e2260494b471a5e8b33c3ea9385bb917.png";